import { Col, Container, Row } from "react-bootstrap";
import styles from "./styles/style.module.scss";
import Card from "./Card";
// Import Swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { useIntl } from "react-intl";

const Statics = ({ counter }) => {
  const { locale } = useIntl();
  const dir = locale === "ar" ? "rtl" : "ltr";
  return (
    <div className={`${styles["main-statics"]} main-statics flex-center`}>
      <Container>
        <div className="cards-div">
          <div className="all-statics-desktop">
            <Row>
              {counter?.content?.items?.map((item, index) => (
                <Col xs={6} sm={6} md={6} lg={4} xl={3} key={index}>
                  <Card item={item} />
                </Col>
              ))}
            </Row>
          </div>
          <div className="all-statics-mobile">
            <div className="container-mobile-div">
              <Swiper
                dir={dir}
                modules={[Autoplay, Navigation]}
                className="mySwiper"
                loop={true}
                spaceBetween={30}
                slidesPerView={2}
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                    spaceBetween: 15,
                  },
                  768: {
                    slidesPerView: 2,
                  },
                  992: {
                    slidesPerView: 3,
                  },
                }}
                navigation={{
                  nextEl: ".swiper-button-nextS",
                  prevEl: ".swiper-button-prevS",
                }}
              >
                {counter?.content?.items?.map((item, index) => (
                  <SwiperSlide key={index}>
                    <Card item={item} />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Statics;
